import { jsx as p } from "react/jsx-runtime";
import $ from "xss";
import { BrandIconId as B } from "./BrandIconId.type.mjs";
import { BrandIconColor as C } from "./BrandIconColor.type.mjs";
import { BrandIconSize as n } from "./BrandIconSize.type.mjs";
function A(a) {
  return a.replace(/[A-Z]+|[0-9]+/g, (s) => `.${s.toLowerCase()}`).replace(/[^a-z0-9]+/g, ".").split(".").filter(Boolean);
}
function b(a) {
  return A(a).map((s) => s.charAt(0).toUpperCase() + s.slice(1)).join("");
}
const g = "images/brand-icons/icon-sprite-2025-11-12.svg", P = (a) => {
  const {
    icon: s,
    size: f,
    fill: d,
    stroke: m,
    style: h,
    className: o,
    ariaLabel: c,
    spriteUrl: l,
    testId: t
  } = a;
  let { color: i } = a;
  const r = ["BrandIcon"], u = (e) => Object.values(C).includes(e);
  if (!i && o && u(o) && (i = o), o && !u(o) && r.push(o), i) {
    const e = b(i);
    d ? r.push(
      e == "AmpfBlue" ? `u-fill${e}` : `u-fillColor${e}`
    ) : m ? r.push(
      e == "AmpfBlue" ? `u-stroke${e}` : `u-strokeColor${e}`
    ) : r.push(`u-bgColor${e} u-fillColorWhite`);
  }
  switch (f) {
    case n.SMALL:
      r.push("BrandIcon--sizeSmall");
      break;
    case n.LARGE:
      r.push("BrandIcon--sizeLarge");
      break;
    case n.MEDIUM:
      r.push("BrandIcon--sizeMedium");
      break;
    case n.DEFAULT:
      r.push("BrandIcon--sizeDefault");
      break;
  }
  const I = () => l === "" ? `#${s}` : l ? `${l}#${s}` : `${window.AMPCOMPATH}${g}#${s}`;
  return s === B.NONE ? null : /* @__PURE__ */ p(
    "svg",
    {
      className: r.join(" "),
      "aria-hidden": c ? void 0 : "true",
      "aria-label": c,
      preserveAspectRatio: "xMinYMin meet",
      style: h,
      "data-testid": t ? `${t}-svg` : null,
      children: /* @__PURE__ */ p(
        "use",
        {
          href: $(I()),
          "data-testid": t ? `${t}-svg-use` : null
        }
      )
    }
  );
};
export {
  g as BRAND_ICON_SPRITE_PATH,
  P as BrandIcon
};
//# sourceMappingURL=BrandIcon.mjs.map
